import { Row, Col, Breadcrumb } from 'react-bootstrap';
import { breadcrumbs } from '../../../constants';
import { Link } from 'react-router-dom';

type BreadcrumbItems = {
    label: string;
    path: string;
    active?: boolean;
};

type PageTitleProps = {
    breadCrumbItems: Array<BreadcrumbItems>;
    title: string;
    isAdmin?: boolean;
};

const PageTitle = ({ breadCrumbItems, title, isAdmin = false }: PageTitleProps) => {
    return (
        <Row>
            <Col>
                <div className='page-title-box'>
                    <div className='page-title-left'>
                        <Breadcrumb listProps={{ className: 'p-2' }}>
                            {isAdmin ? (
                                <li className={'breadcrumb-item'}>
                                    <Link to={'/admin/dashboard/home'}>Admin Panel</Link>
                                </li>
                            ) : (
                                <li className={'breadcrumb-item'}>
                                    <Link to={'/dashboard'}>{breadcrumbs}</Link>
                                </li>
                            )}
                            {breadCrumbItems.map((item, index) => {
                                return item.active ? (
                                    <li className={'breadcrumb-item'} key={index.toString()}>
                                        {item.label}
                                    </li>
                                ) : (
                                    <li className={'breadcrumb-item'} key={index.toString()}>
                                        <Link to={item.path}>{item.label}</Link>
                                    </li>
                                );
                            })}
                        </Breadcrumb>
                    </div>
                </div>
            </Col>
        </Row>
    );
};

export default PageTitle;
